module.exports = __webpack_public_path__ + "img/petstairs15.6434f4a5.jpg";